import { useState, useRef } from 'react';

export function useAudioPlayback() {
  const [playingFileKey, setPlayingFileKey] = useState<string | null>(null);
  const [audioProgress, setAudioProgress] = useState(0);
  const [isBuffering, setIsBuffering] = useState(false);
  const audioRef = useRef<HTMLAudioElement | null>(null);

  const togglePlay = (fileKey: string) => {
    if (playingFileKey === fileKey) {
      audioRef.current?.pause();
      setPlayingFileKey(null);
      setIsBuffering(false);
    } else {
      setPlayingFileKey(fileKey);
      setAudioProgress(0);
      setIsBuffering(true);
      setTimeout(() => {
        if (audioRef.current) {
          audioRef.current.play().catch(err => {
            console.error("Audio playback error:", err);
            setIsBuffering(false);
          });
        }
      }, 0);
    }
  };

  const handleTimeUpdate = (e: React.SyntheticEvent<HTMLAudioElement>) => {
    const target = e.target as HTMLAudioElement;
    if (target.duration) {
      setAudioProgress((target.currentTime / target.duration) * 100);
    }
  };

  const handleEnded = () => {
    setPlayingFileKey(null);
    setAudioProgress(0);
  };

  const handlePlaying = () => setIsBuffering(false);
  const handleWaiting = () => setIsBuffering(true);

  return {
    playingFileKey,
    setPlayingFileKey,
    audioProgress,
    setAudioProgress,
    isBuffering,
    setIsBuffering,
    audioRef,
    togglePlay,
    handleTimeUpdate,
    handleEnded,
    handleAudioTimeUpdate: handleTimeUpdate,
    handleAudioEnded: handleEnded,
    handlePlaying,
    handleWaiting
  };
}
